module.exports = __webpack_public_path__ + "static/media/Soja.cbc46052.png";